import React from 'react';

const TermsAndConditionContext = React.createContext();

export default TermsAndConditionContext;
